(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trColumnToggle', trColumnToggle);

  function trColumnToggle() {
    const directive = {
      restrict: 'E',
      scope: {
        columnSettings: '=',
        userSettings: '=',
        tableName: '@'
      },
      controller: 'ColumnToggleController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/directives/column-toggle/column-toggle.view.html'
    };
    return directive;
  }
})();
